export default function Purchase() {
    return (
        <div> </div>
    )

}